import { useEffect } from "react";
import { useSignal } from "@preact/signals-react";

import mainStore from "store/mainStore";
import StdButton from "components/Buttons/StdButton";
import { CheckCircleIcon } from "components/Icons";

const ModalTags = (props) => {
  const selectedTags = useSignal([]);
  const {
    store,
    record: recordWizard,
    updateRecord,
    updateStore,
  } = mainStore.getState();
  const { product, id } = props.record || {};
  const { tags } = product || {};

  const toggleTag = (key) => {
    selectedTags.value = selectedTags.value.includes(key)
      ? selectedTags.value.filter((k) => k !== key)
      : [...selectedTags.value, key];
  };

  const handleAddTags = () => {
    const _store = { ...store, lines: new Map(store.lines) };
    const _record = { ...recordWizard, lines: new Map(recordWizard.lines) };

    const selectedTagsNames = selectedTags.value
      .map((key) => (tags[key] ? tags[key].name : ""))
      .filter(Boolean)
      .join(", ");
    const createMap = _store.lines.get("create");

    if (createMap?.has(id)) {
      const line = { ...createMap.get(id), note: selectedTagsNames };
      createMap.set(id, line);
    }

    if (_record.lines.has(id)) {
      const line = { ..._record.lines.get(id), note: selectedTagsNames };
      _record.lines.set(id, line);
    }

    updateStore(_store);
    updateRecord(_record);
    props.onClose();
  };
  useEffect(() => {
    const line = recordWizard.lines.get(id);

    if (line?.note) {
      selectedTags.value = line.note
        .split(",")
        .map((tagName) => tagName.trim())
        .filter(Boolean);
    } else {
      selectedTags.value = [];
    }
  }, [id]);
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-2 gap-4">
        {tags &&
          Object.keys(tags).length !== 0 &&
          Object.entries(tags).map(([key, tag], index, arr) => (
            <div
              key={key}
              className={`w-full px-5 py-3 hover:scale-100 border cursor-pointer duration-100 transform rounded-lg transition-all flex items-center space-x-4 justify-between ${
                selectedTags.value.includes(key)
                  ? "bg-green-400 border-green-600"
                  : "bg-green-100 border-green-200"
              }`}
              onClick={() => toggleTag(key)}
            >
              <span className="">{tag.name}</span>
              {selectedTags.value.includes(key) && (
                <CheckCircleIcon
                  width={22}
                  className="fill-green-700 justify-self-center"
                />
              )}
            </div>
          ))}
      </div>

      <div className="flex justify-center">
        <StdButton
          style="p-2 bg-blue-500 text-white rounded-lg w-full"
          onClick={handleAddTags}
          content={"sale.lines.add_tags"}
        />
      </div>
    </div>
  );
};

export default ModalTags;
